import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { SortOrder } from '@/components/ui/table'
import { Comment } from '@/models/features/comments.models'

import { authAPI } from '../new-api'

export type GetPendingCommentsRequest = {
  buildingId?: number
  groupId?: string
  skip: number
  limit: number
  search?: string
  sortBy?: string
  sortOrder?: SortOrder
}

export type GetPendingCommentsResponse = {
  data: Comment[]
  count: number
}

export const GET_PENDING_COMMENTS_QUERY_KEY = 'useGetPendingComments'
export const getPendingCommentsQueryKey = (data: GetPendingCommentsRequest) => [
  GET_PENDING_COMMENTS_QUERY_KEY,
  data,
]

export const getPendingComments = async (data: GetPendingCommentsRequest, signal?: AbortSignal) => {
  const { ...params } = data
  const response = await authAPI.get<GetPendingCommentsResponse>('/group/dashboard/comment', {
    params,
    signal,
  })
  return response.data
}

export const useGetPendingComments = (data: GetPendingCommentsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getPendingComments(data, signal),
    queryKey: getPendingCommentsQueryKey(data),
  })
}
